<ng-container *transloco="let t;">

  <div class="card p-mb-4" *ngIf="showObserver || showObserverGem" [ngClass]="{'card-disabled': disabled === true }">

    <ng-container *ngIf="showObserver">
      <div class="p-grid">
        <div class="p-col-fixed" style="width: 40px">
          <p>
            <app-form-control [cid]="'own_observer'" [control]="subForm.get('checks.own_observer')" [type]="'checkbox'" [noMargin]="true"></app-form-control>
          </p>
        </div>
        <div class="p-col">
          <p [innerHtml]="texts.orderform_own_observer"></p>
        </div>
      </div>

      <app-participant-form [id]="'observer'" [form]="subForm.get('data')" [disabled]="false" [settings]="settings.observer" #observer></app-participant-form>
    </ng-container>

    <hr *ngIf="showObserver && showObserverGem" />

    <!-- HR Observer Section - mit ngSwitch basierend auf hrDisplayMode -->
    <ng-container *ngIf="showObserverGem" [ngSwitch]="hrDisplayMode">
      
      <!-- Fall E: Checkbox "eigener HR" (HR mandatory + eigener HR erlaubt) -->
      <ng-container *ngSwitchCase="'checkbox_own'">
        <div class="p-grid">
          <div class="p-col-fixed" style="width: 40px">
            <p>
              <app-form-control [cid]="'own_observer_gem'" [control]="subForm.get('checks.own_observer_gem')" [type]="'checkbox'" [noMargin]="true"></app-form-control>
            </p>
          </div>
          <div class="p-col">
            <p [innerHtml]="texts.orderform_own_observer_gem"></p>
          </div>
        </div>
      </ng-container>

      <!-- Fall B: Checkbox "HR benötigt" (HR optional + kein eigener HR) -->
      <ng-container *ngSwitchCase="'checkbox_needed'">
        <div class="p-grid">
          <div class="p-col-fixed" style="width: 40px">
            <p>
              <app-form-control [cid]="'hr_needed'" [control]="subForm.get('checks.hr_needed')" [type]="'checkbox'" [noMargin]="true"></app-form-control>
            </p>
          </div>
          <div class="p-col">
            <p>{{ t('orderform.hr_observer_needed') }}</p>
          </div>
        </div>
      </ng-container>

      <!-- Fall C: Dropdown (HR optional + eigener HR erlaubt) -->
      <ng-container *ngSwitchCase="'dropdown'">
        <div class="p-mb-3">
          <app-form-control [cid]="'hr_selection_mode'" [control]="subForm.get('checks.hr_selection_mode')" 
            [type]="'select'" [options]="hrDropdownOptions" [label]="t('orderform.hr_observer_selection')"></app-form-control>
        </div>
      </ng-container>

      <!-- Participant Form -->
      <app-participant-form *ngIf="settings.observer_gem.visible" [id]="'observer_gem'" [form]="subForm.get('data')" [disabled]="false" [settings]="settings.observer_gem" #observer_gem></app-participant-form>
      
    </ng-container>

    <div class="disabled-screen"><i class="pi pi-lock"></i></div>

  </div>

</ng-container>
